import { render, staticRenderFns } from "./nav-group-item.vue?vue&type=template&id=ac808f4a&"
import script from "./nav-group-item.vue?vue&type=script&lang=js&"
export * from "./nav-group-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports